import { render, staticRenderFns } from "./order_action.vue?vue&type=template&id=5eef33aa&scoped=true&"
import script from "./order_action.vue?vue&type=script&lang=js&"
export * from "./order_action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eef33aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eef33aa')) {
      api.createRecord('5eef33aa', component.options)
    } else {
      api.reload('5eef33aa', component.options)
    }
    module.hot.accept("./order_action.vue?vue&type=template&id=5eef33aa&scoped=true&", function () {
      api.rerender('5eef33aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_action.vue"
export default component.exports